export const DEVICE: {
    [s: string]: string
} = {
    PC: "PC",
    SP: "SP"
}
